//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { status } from 'nprogress';
import { auditEditApi } from '@/api/store';
import Tinymce from '@/components/Tinymce';
export default {
  components: {
    Tinymce: Tinymce
  },
  data: function data() {
    return {
      dialogVisible: false,
      options: [{
        label: '通过',
        value: 1
      }, {
        label: '未审核',
        value: 0
      }, {
        label: '不通过',
        value: -1
      }],
      loadingBtn: false,
      auditId: null,
      auditTitle: '',
      auditStatus: null,
      auditText: ''
    };
  },
  methods: {
    setOpen: function setOpen(id, status, text) {
      console.log('进了组件', id, status, text);
      this.auditId = id, this.auditStatus = status;
      this.auditText = text;
      this.dialogVisible = true;
      // console.log('进了组件', id, this.dialogVisible)
    },
    //提交审核
    auditEdit: function auditEdit() {
      var _this = this;
      this.loadingBtn = true;
      var reqData = {
        id: this.auditId,
        isVerify: this.auditStatus,
        verifyReason: this.auditText
      };
      if (this.auditStatus == -1 && !this.auditText) {
        this.loadingBtn = false;
        // this.dialogVisible = false
        return this.$message.warning('驳回时必须填写审核备注');
      } else {
        auditEditApi(reqData).then(function (res) {
          _this.$message.success('已提交审核内容');
          _this.loadingBtn = false;
          _this.dialogVisible = false;
          _this.auditStatus = null;
          _this.auditText = '';
          _this.$emit('auditEdit', 'spu');
        }).catch(function (err) {
          _this.$message.error(err);
          _this.auditStatus = null;
          _this.auditText = '';
          _this.loadingBtn = false;
          _this.dialogVisible = false;
        });
      }

      // this.dialogVisible=false;
    }
  }
};